import { StyleSheet } from 'aphrodite/no-important';

export default StyleSheet.create({
    image: {
        display: 'block',
        backgroundColor: '#717171',
        overflow: 'hidden',
        width: '30px',
        position: 'relative',
        zIndex: 1,
        flex: '0 0 30px',
        borderRadius: '50%',
        height: '30px',
        maxWidth: 'unset'
    }
});



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Image/styles.js